<template>
	<div>

		<div class="text-right">
			<!-- close Ticket  Btn -->
			<v-btn  text small 
			v-if="$store.state.user_type!=$keys.WHOLESALER && ticket_details.status==$keys.OPEN" @click="confirmCloseIssue(ticket_id)" 
			>
			<v-icon color="#6D7C8E" small> mdi-window-close</v-icon>
			<span class="secodry-text-2">{{$lang.CLOSE_TICKET}}</span>
		</v-btn>

	</div>


	<v-row class="mt-2" justify="space-between">
		<v-col md="8"  cols="">
			<v-row class="" justify="space-between">
				<v-col md="4" class="filter-sub-title">
					<v-card class="d-flex flex-row mb-6" flat >
						<v-card  flat >
							<img src="../../assets/order.svg" alt="img"  width="25px" class="mt-3 mr-1">
						</v-card>
						<v-card  flat >
							<p>{{$lang.ISSUE_ID}}</p>
							<p class="sub-title-text">{{ticket_id}}</p>
						</v-card>
					</v-card>

				</v-col>
				<v-col md="4" class="filter-sub-title">
					<v-card class="d-flex flex-row mb-6" flat >
						<v-card  flat >
							<img src="../../assets/calender.svg" alt="img"  width="25px" class="mt-3 mr-1">
						</v-card>
						<v-card  flat >
							<p>{{$lang.RAISED_ON}}</p>
							<p class="sub-title-text">{{ticket_details.raised_on}}</p>
						</v-card>
					</v-card>

				</v-col>
				<v-col md="4" class="filter-sub-title"  >
					<v-card class="d-flex flex-row mb-6" flat v-if="ticket_details.status!=$keys.OPEN"  >
						<v-card  flat >
						</v-card>
						<v-card  flat >
							<p>{{$lang.RESOLVED_ON}}</p>
							<p class="sub-title-text">{{ticket_details.closed_on}}</p>
						</v-card>
					</v-card>
				</v-col>
			</v-row>
			<!-- starus block -->
			<div>
				<span :class="'issue-'+ticket_details.status.toLowerCase()">{{ticket_details.status}}</span>
			</div>
			<!--  decription block -->
			<v-row >
				<v-col md="6" class="filter-sub-title">
					<p class="sub-title-text-dark">{{$lang.CATEGORY}} </p>
					<p class="secondary-text">{{ticket_details.category}}</p>
				</v-col>
				<v-col md="6" class="filter-sub-title">
					<p class="sub-title-text-dark">{{$lang.DESCRIPTION}} </p>
					<p class="secondary-text">{{ticket_details.description}}</p>
				</v-col>
			</v-row>

			<!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->
			<!-- $$$$$$ COMMNET BLOCK $$$$$ -->
			<!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->

			<v-row class="large-screen" >
				<v-col md="7" class="filter-sub-title">
					<comment-block :comment_list="comment_list" :ticket_id="ticket_id"  :ticket_details="ticket_details" @update-comment-list="updateComments"/>
				</v-col>
			</v-row>


		</v-col>
		<!--  dhipment details -->
		<v-col md="4" class=" border-l">
			<shipment-details-block :shipment_details="shipment_details"/>
		</v-col>
	</v-row>

	<!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->
	<!-- $$$$$$ COMMNET BLOCK  for  tab screen $$$$$ -->
	<!-- $$$$$$$$$$$$$$$$$$$$$$$$$$$$ -->

	<v-row class="small-screen" >
		<v-col md="7" class="filter-sub-title">
			<comment-block :comment_list="comment_list" :ticket_id="ticket_id"  :ticket_details="ticket_details" @update-comment-list="updateComments"/>
		</v-col>
	</v-row>


	<common-confirmation-dialog :dialog="dialog" :YesClickHanler="closeIssue" />

</div>
</template>

<script>
export default{
	components: {
		ShipmentDetailsBlock :()=>import('./child/ShipmentDetailsBlock.vue'),
		CommentBlock :()=>import('./child/CommentBlock.vue'),
		CommonConfirmationDialog :()=>import('@/components/common-components/CommonConfirmationDialog.vue'),

	},
	data(){
		return{
			comment_list: [],
			ticket_id:"",
			ticket_details:{
				category: "",
				raised_on:"",
				closed_on: "",
				description: "",
				status: "",
				id:null,
			},
			shipment_details:{
				number_of_packets: null,
				challan_number: "",
				payment_mode: "",
				shipment_amount: "",
				shipment_id: "",
				shipment_status: "",
				retailer_mobile_number:"",
				retailer_firm_name:"",
				retailer_id:"",
				shipment_created:""
			},
			dialog:{
				flag:false,
				msg:"",
				ticket_id:"",
				name:"",
			}


		}
	},
	created(){
		/*  show and hide the back btn*/ 
		this.ticket_id= this.decrypt(this.$route.params.ticket_id)
		this.getTicketDetails()
	},
	methods:{
		/*Fetching support ticket details from the API */ 
		getTicketDetails(){
			this.$store.dispatch('setPageLoader', true)
			const self=this
			let params={
				ticket_id:self.ticket_id,
			};

			const successHandler = (response) => {
				if (response.data.success){
					let data= response.data.data
					self.ticket_details.category=data.category;
					self.ticket_details.closed_on=data.closed_on;		
					self.ticket_details.raised_on=data.raised_on;		
					self.ticket_details.description=data.description;
					self.ticket_details.status=data.status;
					self.ticket_details.id=data.id;

					self.shipment_details.number_of_packets=data.number_of_packets
					self.shipment_details.challan_number=data.challan_number
					self.shipment_details.payment_mode=data.payment_mode
					self.shipment_details.shipment_amount=data.shipment_amount
					self.shipment_details.shipment_id=data.shipment_id
					self.shipment_details.shipment_status=data.shipment_status
					self.shipment_details.retailer_firm_name=data.retailer_firm_name
					self.shipment_details.retailer_mobile_number=data.retailer_mobile_number
					self.shipment_details.retailer_id=data.retailer_id
					self.shipment_details.shipment_created=data.shipment_created

					self.comment_list=data.comment_list.reverse()
				}
			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)
			};

			self.request_GET( self,self.$urls.TICKET_DETAILS,params,successHandler,null,null,finallyHandler)

		},
		/*Add  new comment and update the comment list */ 
		updateComments(comment_list){
			this.comment_list=comment_list
		},
		/* Open confimation dialog for cancelation */ 
		confirmCloseIssue(ticket_id){

			this.dialog.ticket_id=ticket_id
			this.dialog.name=ticket_id
			this.dialog.flag=true
			this.dialog.msg="want to Close support  Ticket"
		},
		closeIssue(){
			this.$store.dispatch('setPageLoader', true)

			const self=this;

			self.btn_loding=true
			var	form = new FormData();
			form.append("ticket_id",self.ticket_id);

			const successHandler = (response) => {
				if (response.data.success){
					this.dialog.flag=false
					this.getTicketDetails()
				}
			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)
			};
			this.request_POST(self,this.$urls.CLOSE_TICKET,form,successHandler,null,null,finallyHandler)
		},

		

	}

}
</script>